import React from 'react'

import { Text } from '@mantine/core'

import {
  SnapshotCard,
  SnapshotFilter,
  snapshotsPath,
} from '#components/SnapshotLand'
import {
  SnapshotListEntries,
  SnapshotListEntriesSkeleton,
} from '#components/SnapshotLand/SnapshotListEntries'

import { Panel } from './Panel'

interface Props {
  scriptId: string
  onClose(): void
  isOpen: boolean
}

export function SnapshotsPanel(props: Props) {
  if (!props.isOpen) return null

  return <SnapshotSidebar scriptId={props.scriptId} onClose={props.onClose} />
}

function SnapshotSidebar(props: { scriptId: string; onClose(): void }) {
  const header = (
    <>
      <Text fw="bold" mr="auto">
        Snapshot History
      </Text>
      <SnapshotFilter scriptId={props.scriptId} />
    </>
  )

  return (
    <Panel header={header} onClose={props.onClose}>
      <React.Suspense fallback={<SnapshotListEntriesSkeleton />}>
        <SnapshotListEntries scriptId={props.scriptId}>
          {(snapshot) => (
            <SnapshotCard
              href={snapshotsPath(props.scriptId, { snap1: snapshot.id })}
              data={snapshot}
            />
          )}
        </SnapshotListEntries>
      </React.Suspense>
    </Panel>
  )
}
